import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { useNullableDealerAccountInfo } from "../stores/hooks/useNullableDealerAccountInfo";
import { VehicleMappingRowItem } from "./useSearchPartPackagesByVehicle";

export const useGetVehicleMappingByWheelId = (
  wheelId: null | string = null
): ModifiedSWRResponse<
  FetcherResult<VehicleMappingRawPayload>,
  VehicleMappingRawPayload
> => {
  const dealer = useNullableDealerAccountInfo();

  const result = useSwrGet<VehicleMappingRawPayload>(
    dealer?.dealerId && wheelId
      ? "/retailSiteWebService/vehicle/getVehicleMappingByWheelId.php"
      : null,
    {
      dealerId: dealer?.dealerId ?? "",
      wheelId: wheelId ?? "",
    }
  );
  return result;
};

type VehicleMappingRawPayload = {
  mappedVehicles: Record<string, VehicleMappingRowItem>;
  wheelId: string;
};

export type VehicleIds = {
  vehicleModelId: string;
  vehicleSubmodelId: string;
  vehicleYearId: string;
};
